import React from "react";
import Navbar from "../shared/Navbar";
import Footer from "../Footer/footer";

const PrivacyPolicy = () => {
  return (
    <div>
        <Navbar/>
        <div className="max-w-4xl mx-auto px-6 py-16 text-gray-800">
        <h1 className="text-3xl font-semibold mb-6">Privacy Policy</h1>

        <p className="mb-4">
            At <strong>Arcium Studio</strong>, we respect your privacy and are committed
            to protecting your personal data. This Privacy Policy explains how we
            collect, use, and safeguard your information in accordance with the Law
            No. 06/L-082 on the Protection of Personal Data of the Republic of Kosovo,
            aligned with the General Data Protection Regulation (GDPR).
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">1. Data We Collect</h2>
        <p className="mb-4">
            When you contact us through our website contact form, we may collect the
            following personal data:
        </p>
        <ul className="list-disc pl-6 mb-4">
            <li>Full name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Message content</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-3">2. Purpose of Data Collection</h2>
        <p className="mb-4">
            Your personal data is collected solely for the purpose of responding to
            your inquiries, providing architectural services, scheduling consultations,
            and maintaining professional communication with you.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">3. Legal Basis for Processing</h2>
        <p className="mb-4">
            We process your personal data based on your explicit consent when you
            submit the contact form, and when it is necessary for legitimate business
            communication.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">4. Data Storage and Security</h2>
        <p className="mb-4">
            Your data is transmitted securely and stored only for as long as necessary
            to fulfill the purpose for which it was collected. We implement appropriate
            technical and organizational measures to protect your data from unauthorized
            access, loss, or misuse.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">5. Data Sharing</h2>
        <p className="mb-4">
            Arcium Studio does not sell, rent, or share your personal data with third
            parties. Your information is used strictly for internal communication and
            client services.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">6. Your Rights</h2>
        <p className="mb-4">
            Under Kosovo data protection law, you have the right to:
        </p>
        <ul className="list-disc pl-6 mb-4">
            <li>Access your personal data</li>
            <li>Request correction or deletion of your data</li>
            <li>Withdraw consent at any time</li>
            <li>Object to data processing</li>
            <li>File a complaint with the Information and Privacy Agency of Kosovo</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-3">7. Cookies</h2>
        <p className="mb-4">
            Our website may use basic cookies to ensure proper functionality. No
            personal data is collected through cookies unless explicitly stated.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">8. Changes to This Policy</h2>
        <p className="mb-4">
            Arcium Studio reserves the right to update this Privacy Policy at any time.
            Any changes will be published on this page with an updated revision date.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">9. Contact Information</h2>
        <p className="mb-4">
            If you have any questions regarding this Privacy Policy or your personal
            data, please contact us at:
        </p>
        <p>
            <strong>Email:</strong> info@arciumstudio.com <br />
            <strong>Company:</strong> Arcium Studio
        </p>

        <p className="mt-8 text-sm text-gray-500">
            Last updated: {new Date().toLocaleDateString()}
        </p>
        </div>
        <Footer/>    
    </div>
  );
};

export default PrivacyPolicy;
